import React, { useState, useEffect } from "react";
import { url } from "../api/api";
import axios from "axios";
import Navbar from "../component/Dasboard/Navbar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Viewwithdrawalmethods = () => {
  const [withdrawalmethod, setWithdrawalmethod] = useState([]);
  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [newMethod, setNewMethod] = useState("");
  const [currentMethod, setCurrentMethod] = useState(null);

  const ITEMS_PER_PAGE = 5;
  const [searchTerm, setSearchTerm] = useState("");
  const [filter, setFilter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);

  const fundingTypes = [
    "All",
    ...new Set(withdrawalmethod?.map((transaction) => transaction.methodname)),
  ];

  const filteredTransactions = withdrawalmethod?.filter((transaction) => {
    const matchesSearchTerm = transaction.methodname
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesFilter = filter === "All" || transaction.methodname === filter;
    return matchesSearchTerm && matchesFilter;
  });

  const totalPages = Math.ceil(filteredTransactions?.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentWithdrawalmethod = filteredTransactions?.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
  };

  const fetchAllWithdrawalMethods = () => {
    axios
      .get(`${url}/withdrawal/fetchallwithdrawal`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setWithdrawalmethod(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching withdrawal methods:", error);
      });
  };

  useEffect(() => {
    fetchAllWithdrawalMethods();
  }, []);

  const handleAddNewMethod = () => {
    setIsAddPopupOpen(true);
  };

  const handleEditMethod = (method) => {
    setCurrentMethod(method);
    setNewMethod(method.methodname);
    setIsEditPopupOpen(true);
  };

  const handleDeleteMethod = (method) => {
    setCurrentMethod(method);
    setIsDeletePopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsAddPopupOpen(false);
    setIsEditPopupOpen(false);
    setIsDeletePopupOpen(false);
    setNewMethod("");
    setCurrentMethod(null);
  };

  const handleAddFormSubmit = (e) => {
    e.preventDefault();
    axios
      .post(
        `${url}/withdrawal/addwithdrawalmethod`,
        { methodname: newMethod },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success("Withdrawal method added successfully!");
        fetchAllWithdrawalMethods();
        handleClosePopup();
      })
      .catch((error) => {
        toast.error("Error adding withdrawal method!");
        console.error("Error adding withdrawal method:", error);
      });
  };

  const handleEditFormSubmit = (e) => {
    e.preventDefault();
    axios
      .patch(
        `${url}/withdrawal/editwithdrawalmethod/${currentMethod._id}`,
        { methodname: newMethod },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success("Withdrawal method updated successfully!");
        fetchAllWithdrawalMethods();
        handleClosePopup();
      })
      .catch((error) => {
        toast.error("Error updating withdrawal method!");
        console.error("Error updating withdrawal method:", error);
      });
  };

  const handleDeleteConfirm = () => {
    axios
      .delete(`${url}/withdrawal/deletewithdrawalmethod/${currentMethod._id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        toast.success("Withdrawal method deleted successfully!");
        fetchAllWithdrawalMethods();
        handleClosePopup();
      })
      .catch((error) => {
        toast.error("Error deleting withdrawal method!");
        console.error("Error deleting withdrawal method:", error);
      });
  };

  return (
    <div className="w-full bg-[#00001A] min-h-screen">
      <Navbar />
      <div className="px-4 py-6 flex flex-col md:flex-row gap-6 w-full mt-20">
        <div className="mb-4 w-full">
          <ToastContainer />
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <input
              type="text"
              className="p-2 border border-gray-300 rounded w-full md:w-auto"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <select
              className="p-2 border border-gray-300 rounded w-full md:w-auto"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              {fundingTypes.map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
            <button
              className="px-6 py-2 rounded border border-white text-white"
              onClick={handleAddNewMethod}
            >
              Add New Withdrawal Method
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full mt-4 text-center">
              <thead className="bg-[#D4F5F9]">
                <tr>
                  <th className="py-2 px-4 border-b">Withdrawal Method</th>
                  <th className="py-2 px-4 border-b">Date</th>
                  <th className="py-2 px-4 border-b">OPTIONS</th>
                </tr>
              </thead>
              <tbody>
                {currentWithdrawalmethod?.map((withdrawalmethos) => (
                  <tr key={withdrawalmethos._id} className="px-10 py-10">
                    <td className="py-2 px-4 text-[#D4F5F9]">
                      {withdrawalmethos.methodname}
                    </td>
                    <td className="py-2 px-4 text-[#fff]">
                      {new Date(
                        withdrawalmethos.createdAt
                      ).toLocaleDateString()}
                    </td>

                    <td className="py-2 px-4 flex gap-6 text-[#fff]">
                      <button
                        className="px-6 py-2 rounded border border-white text-white"
                        onClick={() => handleEditMethod(withdrawalmethos)}
                      >
                        EDIT
                      </button>
                      <button
                        className="px-6 py-2 rounded border border-white text-white"
                        onClick={() => handleDeleteMethod(withdrawalmethos)}
                      >
                        DELETE
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-between items-center mt-4">
            <button
              className="p-2 bg-gray-300 rounded disabled:bg-gray-400"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="text-white">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="p-2 bg-gray-300 rounded disabled:bg-gray-400"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Add Popup Form */}
      {isAddPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded w-11/12 md:w-1/3">
            <h2 className="text-2xl mb-4">Add New Withdrawal Method</h2>
            <form onSubmit={handleAddFormSubmit}>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded mb-4"
                placeholder="Enter withdrawal method"
                value={newMethod}
                onChange={(e) => setNewMethod(e.target.value)}
                required
              />
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded"
                  onClick={handleClosePopup}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded"
                >
                  Add Method
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Popup Form */}
      {isEditPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded w-11/12 md:w-1/3">
            <h2 className="text-2xl mb-4">Edit Withdrawal Method</h2>
            <form onSubmit={handleEditFormSubmit}>
              <input
                type="text"
                className="w-full p-2 border border-gray-300 rounded mb-4"
                placeholder="Enter new method name"
                value={newMethod}
                onChange={(e) => setNewMethod(e.target.value)}
                required
              />
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-500 text-white rounded"
                  onClick={handleClosePopup}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-500 text-white rounded"
                >
                  Update Method
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Popup */}
      {isDeletePopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded w-11/12 md:w-1/3">
            <h2 className="text-2xl mb-4">Confirm Deletion</h2>
            <p>Are you sure you want to delete the withdrawal method "{currentMethod?.methodname}"?</p>
            <div className="flex justify-end gap-4 mt-4">
              <button
                type="button"
                className="px-4 py-2 bg-gray-500 text-white rounded"
                onClick={handleClosePopup}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 bg-red-500 text-white rounded"
                onClick={handleDeleteConfirm}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Viewwithdrawalmethods;
